import Apollo from '@/store/interfaces/Apollo'
import gql from 'graphql-tag'
import { storage } from '@/utils/storage'

import { chapter, episode, homepage, config, endPage } from './parts'
import data from '@/assets/data'
const { data : { aboutPages } } = data

const apollo = new Apollo(process.env.VUE_APP_CRAFT_API, false)
apollo.setToken('Bearer ' + process.env.VUE_APP_CRAFT_TOKEN)
const graphqlClient = apollo.client

const site = process.env.VUE_APP_CRAFT_WEBSITE

class APICraft {

  getHomepage() {
    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchHomepage {
            entry (site: "${site}", type: "sthomepage") {
              ... on sthomepage_sthomepage_Entry {
                ${homepage}
              }
            }
          }
        `
      })
        .then(res => {
          const result = res.data.entry

          resolve(result)
          storage.setItem(`fetchHomepage`, result)
        })
        .catch(err => {
          console.error('Error catching homepage ', err)
        })
    })
    const cache = storage.getItem(`fetchHomepage`)

    return {
      request,
      cache
    }
  }

  getEndpage() {
    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchEndpage {
            entry (site: "${site}", type: "stendpage") {
              ... on stendpage_stendpage_Entry {
                ${endPage}
              }
            }
          }
        `
      })
        .then(res => {
          const result = res.data.entry

          resolve(result)
          storage.setItem(`fetchEndpage`, result)
        })
        .catch(err => {
          console.error('Error catching endpage ', err)
        })
    })
    const cache = storage.getItem(`fetchHomepage`)

    return {
      request,
      cache
    }
  }

  getConfig() {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchConfig {
            entry (site: "${site}", type: "bouyguesConfig") {
              ... on bouyguesConfig_bouyguesConfig_Entry {
                ${config}
              }
            }
          }
        `
      })
        .then(res => {
          const result = res.data.entry

          resolve(result)
          storage.setItem(`fetchConfig`, result)
        })
        .catch(err => {
          console.error('Error catching config ', err)
        })
    })
    const cache = storage.getItem(`fetchConfig`)

    return {
      request,
      cache
    }
  }

  getChapters() {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchChapters {
            chapters: entries (site: "${site}", type: "bouyguesChapter", level: 1) {
              ... on bouyguesChapter_bouyguesChapter_Entry {
                ${chapter}
                episodes: children {
                  ... on bouyguesChapter_bouyguesChapter_Entry {
                    ${episode}
                  }
                }
              }
            }
          }
        `
      })
      .then(res => {
        const result = res.data.chapters

          resolve(result)
          storage.setItem(`fetchEntries`, result)
        })
        .catch(err => {
          console.error('Error catching entries ', err)
        })
    })
    const cache = storage.getItem(`fetchEntries`)

    return {
      request,
      cache
    }
  }

  getGenericAboutPage(name) {
    const pageData = aboutPages.find(page => page.slug === name)
    const {craftType: type, craftEntryType: entryType } = pageData

    const request = new Promise((resolve, reject) => {
      graphqlClient.query({
        query: gql`
          query fetchHomepage {
            entry (site: "bouyguesHotel", type: "${type}") {
              id
              ... on ${entryType} {
                id
                title
                ${entryType === 'stabout_stabout_Entry' ? 'subtitle: sousTitre' : ''}
                image {
                  ... on default_Asset {
                    id
                    url
                    alt
                  }
                }
                wysiwyg
              }
            }
          }
        `
      })
      .then(res => {
        const result = res.data.entry
        
        resolve(result)
        storage.setItem(`fetchAbout`, result)
      })
      .catch(err => {
        console.log('name', name)

        console.error('Error catching about ', err)
      })
    })

    const cache = storage.getItem(`fetchAbout`)
    
    return {
      request,
      cache
    }
  }

  imgSize({ id, width, height }) {
    const args = arguments

    const request = new Promise((resolve, reject) => {
      let query = {}

      if (width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int, $height: Int) {
              asset(id: $id) {
                ... on bouygues_Asset {
                  url(width: $width, immediately: true, height: $height)
                }
              }
            }
          `,
          variables: { id, width, height }
        }
      }
      else if (width && !height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $width: Int) {
              asset(id: $id) {
                ... on bouygues_Asset {
                  url(width: $width, immediately: true)
                }
              }
            }
          `,
          variables: { id, width }
        }
      }
      else if (!width && height) {
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument], $height: Int) {
              asset(id: $id) {
                ... on bouygues_Asset {
                  url(height: $height, immediately: true)
                }
              }
            }
          `,
          variables: { id, height }
        }
      }
      else {
        console.log('No width or height provided')
        query = {
          query: gql`
            query fetchImg ($id: [QueryArgument])  {
              asset(id: $id) {
                  url
              }
            }
          `,
          variables: { id }
        }
      }

      graphqlClient.query(query)
        .then(res => {
          resolve(res.data.asset.url)

          const result = res.data.asset.url

          resolve(result)
          storage.setItem(`fetchImg_${JSON.stringify(args)}`, result)
        })
        .catch(err => {
          console.error('Error catching global params ', err)
        })
    })

    const cache = storage.getItem(`fetchImg_${JSON.stringify(args)}`)

    return {
      request,
      cache
    }
  }
}

export const api = new APICraft()